import React from 'react';
import { Award, Users, Target, Rocket } from 'lucide-react';

const About = () => {
  const milestones = [
    { year: 2008, text: 'Fondarea companiei Interlink Comunicații' },
    { year: 2010, text: 'Lansarea serviciilor de internet prin fibră optică' },
    { year: 2015, text: 'Extinderea în 50+ localități' },
    { year: 2018, text: 'Lansarea serviciilor pentru business' },
    { year: 2020, text: 'Implementarea tehnologiei GPON' },
    { year: 2023, text: 'Peste 50,000 de clienți activi' }
  ];

  const values = [
    {
      icon: <Users className="h-12 w-12 text-primary" />,
      title: 'Orientare către Client',
      description: 'Satisfacția clienților este prioritatea noastră principală'
    },
    {
      icon: <Target className="h-12 w-12 text-primary" />,
      title: 'Calitate și Inovație',
      description: 'Investim constant în tehnologii de ultimă generație'
    },
    {
      icon: <Award className="h-12 w-12 text-primary" />,
      title: 'Profesionalism',
      description: 'Echipa noastră este formată din specialiști certificați'
    },
    {
      icon: <Rocket className="h-12 w-12 text-primary" />,
      title: 'Dezvoltare Continuă',
      description: 'Ne extindem și îmbunătățim serviciile în permanență'
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 hero-pattern relative overflow-hidden">
        <div className="container mx-auto text-center relative z-10">
          <div className="max-w-4xl mx-auto bg-white/5 backdrop-blur-lg p-8 rounded-2xl border border-white/10">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
              Despre Interlink Comunicații
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-white/80">
              15 ani de excelență în telecomunicații
            </p>
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary/50 to-primary opacity-90"></div>
      </section>

      {/* Company Overview */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto max-w-4xl">
          <div className="prose prose-lg mx-auto">
            <p className="text-xl text-gray-700 leading-relaxed">
              Interlink Comunicații SRL este o companie fondată în municipiul Bălți, activă în domeniul telecomunicațiilor și securității din anul 2016. 
              Suntem specializați în furnizarea de internet de mare viteză, telefonie, televiziune digitală și montarea sistemelor de supraveghere video. Utilizăm echipamente de ultimă generație de la cele mai renumite branduri, asigurând servicii de înaltă calitate și fiabilitate sporită.
              Pe lângă serviciile de telecomunicații, Interlink Comunicații SRL oferă soluții complete de securitate, inclusiv sisteme antiincendiare, control acces, videodomofoane cu înregistrarea fluxului video 24/7 pe serverele noastre și alarme antiefracție, adaptate nevoilor clienților rezidențiali și business. 
              Cu o echipă de profesioniști calificați și echipamente de top, compania garantează soluții eficiente, sigure și conforme cu cele mai noi standarde tehnologice.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">Valorile Noastre</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex justify-center mb-4">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-center mb-2">{value.title}</h3>
                <p className="text-gray-600 text-center">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto max-w-4xl">
          <h2 className="text-3xl font-bold text-center mb-12">Istoria Noastră</h2>
          <div className="space-y-8">
            {milestones.map((milestone, index) => (
              <div key={index} className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-24 pt-1">
                  <span className="text-xl font-bold text-primary">{milestone.year}</span>
                </div>
                <div className="flex-grow pb-8 border-l-2 border-primary pl-8 relative">
                  <div className="absolute w-3 h-3 bg-primary rounded-full -left-[7px] top-2"></div>
                  <p className="text-lg text-gray-700">{milestone.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;